import "./Aushadha.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsArrowRight, BsArrowLeft, BsDot } from "react-icons/bs";
import { useRef } from "react";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import introVideo from "../videos/aushadhi.MOV";

export const Aushadha = () => {
  const aushadhisliderRef = useRef(null);
  const aushadhislider02Ref = useRef(null);
  const aushadhislider03Ref = useRef(null);

  const bannerRef = useRef(null);

  var banner_slider_settings = {
    className: "aushadhi-banner-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 2.7,
    slidesToScroll: 1,
    arrows: false,
  };

  var aushadhi_slider_settings = {
    className: "aushadhi-grid-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <AushadhiNextArrow />,
    prevArrow: <AushadhiPrevArrow />,
  };

  var aushadhi_slider02_settings = {
    className: "aushadhi-slider02-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Aushadhi02NextArrow />,
    prevArrow: false,
  };

  var aushadhi_slider03_settings = {
    className: "aushadhi-testimonial-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Aushadhi03NextArrow />,
    prevArrow: <Aushadhi03PrevArrow />,
  };

  function AushadhiNextArrow() {
    return (
      <BsArrowRight
        className="aushadhi_nextarrow"
        onClick={handleSlider_01_NextClick}
      />
    );
  }

  function AushadhiPrevArrow() {
    return (
      <BsArrowLeft
        className="aushadhi_prevarrow"
        onClick={handleSlider_01_PrevClick}
      />
    );
  }

  function Aushadhi02NextArrow() {
    return (
      <div
        onClick={handleSlider_02_NextClick}
        className="aushadhi02_nextarrow"
      >
        Next
      </div>
    );
  }

  function Aushadhi03NextArrow() {
    return (
      <BsArrowRight
        className="aushadhi-slider03-nextarrow"
        onClick={handleSlider_03_NextClick}
      />
    );
  }

  function Aushadhi03PrevArrow() {
    return (
      <BsArrowLeft
        className="aushadhi-slider03-prevarrow"
        onClick={handleSlider_03_PrevClick}
      />
    );
  }

  const handleSlider_03_NextClick = () => {
    aushadhislider03Ref.current.slickNext();
  };

  const handleSlider_03_PrevClick = () => {
    aushadhislider03Ref.current.slickPrev();
  };

  const handleSlider_01_NextClick = () => {
    aushadhisliderRef.current.slickNext();
  };

  const handleSlider_01_PrevClick = () => {
    aushadhisliderRef.current.slickPrev();
  };

  const handleSlider_02_NextClick = () => {
    aushadhislider02Ref.current.slickNext();
  };

  return (
    <div id="project-aushadhi-main-wrapper">
      <div id="aushadhi-banner-section-wrap">
        <div id="aushadhi-banner-section-media-wrap">
          <Video autoplay loop id="banner-video">
            <source src={introVideo} type="video/webm" />
          </Video>
        </div>
        <div id="aushadhi-banner-section-text-wrap">
          <div id="aushadhi-banner-section-text-01">Aushadha Nagari</div>
          <div id="aushadhi-banner-section-text-02">
            An ideal location to blend nature with residence
          </div>
        </div>

        <div id="aushadhi-banner-section-slider-wrap">
          <Slider ref={bannerRef} {...banner_slider_settings}>
            <div className="aushadhi-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza01.JPG" alt="" />
            </div>

            <div className="aushadhi-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza02.jpeg" alt="" />
            </div>

            <div className="aushadhi-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza03.jpeg" alt="" />
            </div>
          </Slider>
        </div>
      </div>

      <div id="project-aushadhi-luxury-wilderness-section-wrap">
        <div id="project-aushadhi-luxury-wilderness-section-title">
          The perfect mix between luxury & wilderness
        </div>
        <div id="project-aushadhi-luxury-wilderness-section-content-para-01">
          Aushadha Nagari (DTCP Approved Layout), a project recently built by
          Vihari Projects, is bordered by prominent educational institutions,
          software and ITIR Zones, as well as government offices like collector
          offices and industrial zones. Additionally, it’s close to ORR and
          offers good access to RGI Airport via nearby roads.
        </div>
      </div>

      <div id="project-aushadhi-image-slider-section-main-wrap">
        <Slider ref={aushadhisliderRef} {...aushadhi_slider_settings}>
          <div>
            <div className="project-aushadhi-image-slider-row-01-wrap">
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-aushadhi-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-aushadhi-image-slider-row-02-image"
              />
            </div>
          </div>

          <div>
            <div className="project-aushadhi-image-slider-row-01-wrap">
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-aushadhi-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-aushadhi-image-slider-row-02-image"
              />
            </div>
          </div>

          <div>
            <div className="project-aushadhi-image-slider-row-01-wrap">
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
              <div className="project-aushadhi-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-aushadhi-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-aushadhi-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-aushadhi-image-slider-row-02-image"
              />
            </div>
          </div>
        </Slider>
      </div>

      <div id="project-aushadhi-why-aushadhi-section-wrap">
        <div id="project-aushadhi-why-aushadhi-section-headline">
          Why Aushadha Nagari ?
        </div>
        <div id="project-aushadhi-why-aushadhi-section-content-para01">
          We believe Aushadha Nagari would create the ideal home for you if the
          pictures haven’t already convinced you.
        </div>
        <div id="project-aushadhi-why-aushadhi-section-content-para02">
          Aushadha Nagari is a project that is very dear to us because of the
          great quality of life we get to build for the inhabitants. Living in
          the city will be less stressful if you have a backyard and top-notch
          amenities at your disposal.
        </div>
        <div id="project-aushadhi-why-aushadhi-section-content-para03">
          You can use the amenities on our website with confidence; anyone can
          use them, small children included. Purchasing a plot at Aushadha
          Nagari is an investment in your long-term financial security, as well
          as in your health and pleasure.
        </div>
      </div>

      <div id="project-aushadhi-schedule-tour-section-wrap">
        <div id="project-aushadhi-schedule-tour-section-headline">
          Schedule your virtual tour.
        </div>
        <button id="project-aushadhi-schedule-tour-section-request-btn">
          REQUEST NOW
        </button>
      </div>

      <div id="project-aushadhi-farmlands-slider02-wrap">
        <Slider ref={aushadhislider02Ref} {...aushadhi_slider02_settings}>
          <div className="project-aushadhi-farmlands-slider02-slide">
            <div className="project-aushadhi-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-aushadhi-farmlands-slider02-image"
              />
            </div>
            <div className="project-aushadhi-farmlands-slider02-details-wrap">
              <span>01</span> <span>Aushadha Nagari</span>
            </div>
          </div>

          <div className="project-aushadhi-farmlands-slider02-slide">
            <div className="project-aushadhi-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-aushadhi-farmlands-slider02-image"
              />
            </div>
            <div className="project-aushadhi-farmlands-slider02-details-wrap">
              <span>02</span> <span>Aushadha Nagari</span>
            </div>
          </div>

          <div className="project-aushadhi-farmlands-slider02-slide">
            <div className="project-aushadhi-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-aushadhi-farmlands-slider02-image"
              />
            </div>
            <div className="project-aushadhi-farmlands-slider02-details-wrap">
              <span>03</span> <span>Aushadha Nagari</span>
            </div>
          </div>
        </Slider>
      </div>

      <hr id="project-aushadhi-features-section-section-divider" />

      <div id="project-aushadhi-features-section-wrap">
        <div id="project-aushadhi-features-section-headline">Features</div>
        <ul id="project-aushadhi-features-section-list-ul">
          <li>Srisailam NH Road Facing Venture</li>
          <li>Near proposed Pharma City</li>
          <li>Near RGI Airport</li>
          <li>MAK Projects mega Residential Township</li>
          <li>Near to ORR</li>
          <li>TS Trading Corporation</li>
          <li>TS gem & Jeweler park</li>
          <li>Moser Boer, HCL, AML, ELI, Hardware Companies</li>
        </ul>
      </div>

      <div id="aushadhi-page-email-section-container">
        <div id="aushadhi-page-email-section-main-wrap">
          <div id="aushadhi-page-email-section-sub-wrap">
            <div id="aushadhi-page-email-section-logo-title-wrap">
              <div id="aushadhi-page-email-section-logo-wrap">
                <img
                  src="./logo01.png"
                  alt="logo"
                  id="aushadhi-page-email-section-logo"
                />
              </div>
              <div id="aushadhi-page-email-section-title">VIHARI PROJECTS</div>
            </div>
            <div id="aushadhi-page-email-section-text">
              Start a new investment with vihari projects{" "}
            </div>

            <div id="aushadhi-page-email-section-input-wrap">
              <input
                type="text"
                id="aushadhi-page-email-section-input-element"
                placeholder="Enter your email id"
              />
              <BsArrowRight id="aushadhi-page-email-section-input-enter-icon" />
            </div>
          </div>
        </div>
      </div>

      <div id="aushadhi-testimonial-section-wrap">
        <div id="aushadhi-testimonial-section-headline">
          Encouraging words from our customers
        </div>
        <Slider ref={aushadhislider03Ref} {...aushadhi_slider03_settings}>
          <div className="aushadhi-testimonial-slider-content-wrap">
            <div className="aushadhi-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aushadhi-testimonial-slider-content-user-name">
              <BsDot className="aushadhi-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>

          <div className="aushadhi-testimonial-slider-content-wrap">
            <div className="aushadhi-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image01"
                />
              </div>
              <div>
                Good and awesome projects. Really it's connecting to both nature
                and luxury style living. In short eco friendly projects. And
                they are very much cooperative
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aushadhi-testimonial-slider-content-user-name">
              <BsDot className="aushadhi-testimonial-slider-content-user-name-dot-icon" />{" "}
              Ansuman Tripathy
            </div>
          </div>

          <div className="aushadhi-testimonial-slider-content-wrap">
            <div className="aushadhi-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="aushadhi-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="aushadhi-testimonial-slider-content-user-name">
              <BsDot className="aushadhi-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};
